
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elektriker-tjenester",
      function () {
        return require("private-next-pages/elektriker-tjenester/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elektriker-tjenester"])
      });
    }
  